<script setup>
import { defineEmits, defineProps, computed, toRefs } from "vue"

const props = defineProps({
  modelValue: {}
});

const { modelValue } = toRefs(props);

const emit = defineEmits(['update:modelValue'])


const columnCount = computed({
  get: () => props.modelValue?.data?.columnCount,
  set: (value) => {
    const newColumnCount = parseInt(value);
    const currentColumns = props.modelValue?.data?.columns || [];

    if (newColumnCount > currentColumns.length) {
      // Add new columns
      for (let i = currentColumns.length; i < newColumnCount; i++) {
        currentColumns.push({ blocks: [], fitContent: false });
      }
    } else if (newColumnCount < currentColumns.length) {
      // Remove excess columns
      currentColumns.splice(newColumnCount);
    }

    emit('update:modelValue', {
      ...props.modelValue,
      data: {
        ...props.modelValue?.data,
        columnCount: newColumnCount,
        columns: currentColumns
      }
    });
  }
})

const columns = computed({
  get: () => props.modelValue?.data?.columns || [],
  set: (newColumns) => {
    emit('update:modelValue', {
      ...props.modelValue,
      data: {
        ...props.modelValue?.data,
        columns: newColumns
      }
    });
  }
})
function toggleFitContent(index) {
  const newColumns = [...columns.value];
  newColumns[index].fitContent = !newColumns[index].fitContent;
  columns.value = newColumns;
}
</script>

<template>
  <div>
    <p>Количество колонок</p>
    <a-input-number v-model:value="columnCount" :min="1" :max="4" />

    <div v-for="(column, index) in columns" :key="index" style="margin-top: 10px;">
      <a-checkbox
          :checked="column.fitContent"
          @change="() => toggleFitContent(index)"
      >
        Колонка {{ index + 1 }}: Ширина по содержимому
      </a-checkbox>
    </div>
	  
  </div>
</template>